import { useContext } from "react";
import { TeacherContext } from '../App'

export default function useTeacherState() {
    return useContext(TeacherContext)
}